import CardActivation from './CardActivation'

export default CardActivation
